// Player/Credits: MUI styled → inline styles.

// Unsplash API guideline: attribution links require utm_campaign=api-credit too.
const UNSPLASH_UTM = '?utm_source=scrolly&utm_medium=referral&utm_campaign=api-credit';

interface Props {
    readonly light: boolean;
    readonly text: string;
    readonly photographerUrl?: string;
}

export default function Credits({ light, text, photographerUrl }: Props) {
    const color = `hsl(0deg 0% ${light ? "100%" : "0%"} / 0.5)`;
    const linkColor = `hsl(0deg 0% ${light ? "100%" : "0%"} / 0.85)`;

    // If we have a photographer URL and the text matches "Foto: Name / Unsplash",
    // render the photographer name and "Unsplash" as clickable links with UTM params.
    const unsplashMatch = photographerUrl ? text.match(/^(Foto:\s*)(.+?)(\s*\/\s*)(Unsplash)$/) : null;

    // The wrapper in Renderer.tsx is `pointer-events: none` so the empty
    // area around the text stays scroll-transparent. We re-enable pointer
    // events only on the inline-block span that contains the link text —
    // Safari does not reliably honour a child's pointer-events override
    // when the ancestor chain passes through multiple `none` nodes.
    return (
        <div
            style={{
                width: "100%",
                padding: "8px 0",
                pointerEvents: "none",
                textAlign: "center",
            }}
        >
            {unsplashMatch ? (
                <span style={{ color, display: "inline-block", pointerEvents: "auto" }}>
                    {unsplashMatch[1]}
                    <a href={`${photographerUrl}${UNSPLASH_UTM}`} target="_blank" rel="noopener noreferrer" style={{ color: linkColor, textDecoration: 'underline', cursor: 'pointer' }}>{unsplashMatch[2]}</a>
                    {unsplashMatch[3]}
                    <a href={`https://unsplash.com${UNSPLASH_UTM}`} target="_blank" rel="noopener noreferrer" style={{ color: linkColor, textDecoration: 'underline', cursor: 'pointer' }}>{unsplashMatch[4]}</a>
                </span>
            ) : (
                <span style={{ color }}>{text}</span>
            )}
        </div>
    );
}
